// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3Ukh2","head":"ProcedureTableInfo_head__py_Gg"};